import { Box, Button, Link, Typography } from '@mui/material'

interface Props {
  accept?: string
  selectFile: (selectedFile: File | undefined) => void
  useButton?: boolean
}

export const DragAndDropFilePicker = (props: Props): JSX.Element => {
  const handleDropFile = (e: React.DragEvent<HTMLDivElement>): void => {
    e.preventDefault()
    e.stopPropagation()

    const selectedFile = e.dataTransfer.files?.[0]

    props.selectFile(selectedFile)
  }

  const handleFileSelect = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const selectedFile = e.target.files?.[0]

    props.selectFile(selectedFile)
  }

  const clearFile = (e: React.MouseEvent<HTMLInputElement>): void => {
    e.currentTarget.value = ''
    props.selectFile(undefined)
  }

  return <Box
    data-testid='filePickerDropArea'
    onDrop={handleDropFile}
    onDragOver={(e) => { e.preventDefault() }}
    sx={{
      border: '2px dashed #908D91',
      borderRadius: '0',
      bgcolor: '#FAFAFA',
      p: '32px',
      width: 'inherit',
      textTransform: 'none',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'default',
      color: 'black'
    }}
  >
    <Typography variant='body1'>
      Drag and drop your file here
    </Typography>

    <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: props.useButton === true ? 'column' : 'row' }}>
      <Typography variant='body1'>
        or
      </Typography>

      { props.useButton === true
        ? <Button
            component='label'
            sx={{
              background: 'linear-gradient(96.34deg, var(--blue-900) 0%, var(--blue-500) 100%)',
              '&:hover': {
                background: 'linear-gradient(96.34deg, #01142b 0%, var(--blue-700) 100%)'
              }
            }}
            variant='contained'
            data-testid='filePickerButton'
        >
          <Typography variant='body1' sx={{ color: 'white' }}>Add your file</Typography>
          <input hidden type='file' name='file' accept={props.accept} onChange={handleFileSelect} onClick={clearFile} data-testid='filePickerInput' />
        </Button>
        : <Link component='label' sx={{ ml: '.25em', cursor: 'pointer' }}>
          <Typography variant='body1' sx={{ color: 'var(--blue-500)' }}>upload here.</Typography>
          <input hidden type='file' name='file' accept={props.accept} onChange={handleFileSelect} onClick={clearFile} data-testid='filePickerInput' />
        </Link>
      }
    </Box>
  </Box>
}
